const difyDomain = 'dify.vanmalock.com';
const config = {
  host: `${window.location.protocol}//${difyDomain}`,
  id: 'fDTn5rkugD9eEqaE',
};
export const loadAIChatBot = () => {
  // 创建配置 script
  const configScript = document.createElement('script');
  configScript.textContent = `
      window.difyChatbotConfig = {
        token: '${config.id}',
        baseUrl: '${config.host}',
        systemVariables: {},
        userVariables: {}
      };
    `;

  // 创建样式
  const style = document.createElement('style');
  style.textContent = `
      #dify-chatbot-bubble-button {
        background-color: #347af6 !important;
      }
      #dify-chatbot-bubble-window {
        width: 24rem !important;
        height: 40rem !important;
        position: fixed !important;
      }
    `;

  // 创建加载 script
  const script = document.createElement('script');
  script.src = `${config.host}/embed.min.js`;
  script.id = config.id;
  script.defer = true;

  // 添加到文档
  document.head.appendChild(style);
  document.body.appendChild(configScript);
  document.body.appendChild(script);
};

export const hideAIChatBot = () => {
  const entrance = document.getElementById('dify-chatbot-bubble-button');
  if (entrance) {
    entrance.style.display = 'none';
  }

  // 同时隐藏聊天窗口，通过模拟点击入口按钮（如果有的话）
  const chatWindow = document.getElementById('dify-chatbot-bubble-window');
  if (chatWindow && chatWindow.style?.display !== 'none') {
    entrance.click();
  }
};

export const showAIChatBot = () => {
  const entrance = document.getElementById('dify-chatbot-bubble-button');
  if (entrance) {
    entrance.style.display = 'unset';
  }
};
